<template>
  <div>
    <el-dialog title="添加示例图" :visible.sync="visible" :close-on-click-modal="false" width="600px">
      <el-form ref="formRef" :model="formData" :rules="formRule" label-width="148px">
        <el-form-item label="示例图名称：" prop="imageName">
          <el-input v-model.trim="formData.imageName" maxlength="10" placeholder="请输入示例图名称" type="text" size="small" />
        </el-form-item>
        <el-form-item label="示例图图片：" prop="sampleImage">
           <!-- @handleChange="sampleHandleChange" -->
          <ElImgUpload
            :isBigImg="true"
            :exist-image="formData.sampleImage"
            placeTxt="提示：图片仅支持上传jpg/png/gif格式，建议尺寸：340-340px"
            @handleChange="sampleHandleChange"/>
        </el-form-item>
        <el-form-item label="拍照提示(非必填)：">
          <el-input type="textarea" v-model.trim="formData.sampleTip" placeholder="请输入提示文字，最多50字" maxlength="50" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="visible = false">取消</el-button>
        <el-button type="primary" :loading="confirmBtnLoading" @click.native="confirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import ElImgUpload from "./upload-element";

const originFormData = {
  imageName: '',
  sampleImage: '',
  sampleTip: ''
}
export default {
  name: "AddSampleImageDia",
  components: { ElImgUpload },
  props: {
    machineTypeId: [String, Number],
  },
  data() {
    return {
      visible: false,

      type: '', // 00示例图 01补充细节图
      formData: originFormData,
      formRule: {
        imageName: [{ required: true, message: '请输入示例图名称', trigger: 'change' }],
        sampleImage: [{ required: true, message: '请上传图片', trigger: 'change' }],
      },
      confirmBtnLoading: false
    };
  },
  methods: {
    open(row) {
      if (row) {
        this.formData = {
          id: row.id,
          imageName: row.imageName,
          sampleImage: row.sampleImage,
          sampleTip: row.sampleTip
        }
        console.log(row)
      } else {
        this.formData = JSON.parse(JSON.stringify(originFormData))
      }
      this.$nextTick(() => {
        this.$refs['formRef']?.clearValidate()
        this.visible = true
      })
    },
    close() {
      this.visible = false
    },
    sampleHandleChange(v) {
      this.formData.sampleImage = v
    },
    confirm() {
      this.$refs['formRef'].validate((vaild) => {
        if (vaild) {
          this.confirmBtnLoading = true
          _api.ImageAdd({
            ...this.formData,
            machineTypeId: this.machineTypeId,
            imageType: '02'
          }).then(() => {
            this.$emit('confirm')
            this.$message.success('操作成功！')
            this.close()
          }).finally(() => {
            this.confirmBtnLoading = false;
          });
        }
      })
    }
  }
};
</script>